import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// This component is a "guard" for our private pages
function ProtectedRoute() {
  // --- THIS IS THE SIMPLIFICATION ---
  // Now that our "brain" is smart, we can just trust it.
  // We no longer need to check localStorage here.
  const { token } = useAuth();

  if (!token) {
    // 2. If no token, "redirect" them to the /login page
    return <Navigate to="/login" replace />;
  }
  // --- END SIMPLIFICATION ---

  // 3. If they *are* logged in, show the "Outlet"
  // (the "Outlet" is the real page they were trying to visit)
  return <Outlet />;
}

export default ProtectedRoute;